export class Vehicle {
    get id() {
        return this.vehicleState.id;
    }
    ;
    get thirdId() {
        return this.vehicleState.thirdId;
    }
    ;
    get plate() {
        return this.vehicleState.plate;
    }
    ;
    get vehicleType() {
        return this.vehicleState.vehicleType;
    }
    ;
    get markId() {
        return this.vehicleState.markId;
    }
    ;
    get modelId() {
        return this.vehicleState.modelId;
    }
    ;
    get frame() {
        return this.vehicleState.frame;
    }
    ;
    get insuranceCarrierId() {
        return this.vehicleState.insuranceCarrierId;
    }
    ;
    get insuranceTakerId() {
        return this.vehicleState.insuranceTakerId;
    }
    get policyNumber() {
        return this.vehicleState.policyNumber;
    }
    ;
    get validityPolicy() {
        return this.vehicleState.validityPolicy;
    }
    ;
    get validityInpeccion() {
        return this.vehicleState.validityInpeccion;
    }
    ;
    get colorId() {
        return this.vehicleState.colorId;
    }
    ;
    get plateDate() {
        return this.vehicleState.plateDate;
    }
    ;
    get transportCardType() {
        return this.vehicleState.transportCardType;
    }
    ;
    get transportCardTypeVisible() {
        return this.vehicleState.transportCardTypeVisible;
    }
    ;
    get transportCardTypeCorresponding() {
        return this.vehicleState.transportCardTypeCorresponding;
    }
    ;
    get observations() {
        return this.vehicleState.observations;
    }
    ;
    set id(id) {
        this.vehicleState.id = id;
    }
    ;
    set thirdId(thirdId) {
        this.vehicleState.thirdId = thirdId;
    }
    ;
    set plate(plate) {
        this.vehicleState.plate = plate;
    }
    ;
    set vehicleType(vehicleType) {
        this.vehicleState.vehicleType = vehicleType;
    }
    ;
    set markId(markId) {
        this.vehicleState.markId = markId;
    }
    ;
    set modelId(modelId) {
        this.vehicleState.modelId = modelId;
    }
    ;
    set frame(frame) {
        this.vehicleState.frame = frame;
    }
    ;
    set insuranceCarrierId(insuranceCarrierId) {
        this.vehicleState.insuranceCarrierId = insuranceCarrierId;
    }
    ;
    set insuranceTakerId(insuranceTakerId) {
        this.vehicleState.insuranceTakerId = insuranceTakerId;
    }
    set policyNumber(policyNumber) {
        this.vehicleState.policyNumber = policyNumber;
    }
    ;
    set validityPolicy(validityPolicy) {
        this.vehicleState.validityPolicy = validityPolicy;
    }
    ;
    set validityInpeccion(validityInpeccion) {
        this.vehicleState.validityInpeccion = validityInpeccion;
    }
    ;
    set colorId(colorId) {
        this.vehicleState.colorId = colorId;
    }
    ;
    set plateDate(plateDate) {
        this.vehicleState.plateDate = plateDate;
    }
    ;
    set transportCardType(transportCardType) {
        this.vehicleState.transportCardType = transportCardType;
    }
    ;
    set transportCardTypeVisible(transportCardTypeVisible) {
        this.vehicleState.transportCardTypeVisible = transportCardTypeVisible;
    }
    ;
    set transportCardTypeCorresponding(transportCardTypeCorresponding) {
        this.vehicleState.transportCardTypeCorresponding = transportCardTypeCorresponding;
    }
    ;
    set observations(observations) {
        this.vehicleState.observations = observations;
    }
    ;
    constructor(vehicleState) {
        this.vehicleState = vehicleState;
    }
    getState() {
        return this.vehicleState;
    }
}
